export const _setAuthPdfPrint = (state, action) => {
  state.authPdfPrint = action.payload;
};
